import { useState } from "react";
import { Loader2, XCircle, CalendarClock, ShieldCheck } from "lucide-react";
import MobileModal from "@/components/MobileModal";

function formatDateIT(iso) {
  if (!iso) return "—";
  try {
    return new Date(iso).toLocaleDateString("it-CH", {
      day: "2-digit", month: "2-digit", year: "numeric",
    });
  } catch {
    return "—";
  }
}

/**
 * Phase 43.21 — Modale di conferma disdetta con grace period.
 * Phase 44.13 — Refactor su MobileModal (body-scroll-lock, safe-area, 100dvh).
 */
export default function CancelSubscriptionModal({ me, busy, onConfirm, onClose }) {
  const [stage] = useState("schedule");
  const periodEnd = me?.current_period_end || me?.billing_cycle_end;
  const planName = me?.plan?.name || me?.plan?.id || "—";
  const remaining = Math.max(
    0,
    (me?.included_deliveries_monthly || 0) - (me?.included_deliveries_used || 0),
  );

  // Phase 44.17 — Footer sticky CTA disdetta.
  const footer = (
    <div className="flex flex-col-reverse sm:flex-row gap-2 sm:justify-end">
      <button
        data-testid="cancel-modal-keep-btn"
        onClick={onClose}
        disabled={busy}
        className="btn-ghost h-11 px-5"
      >
        Mantieni piano attivo
      </button>
      <button
        data-testid="cancel-modal-confirm-btn"
        onClick={onConfirm}
        disabled={busy || stage !== "schedule"}
        className="h-11 px-5 rounded-xl bg-dapnow-red text-white font-semibold tracking-tight flex items-center justify-center gap-2 hover:opacity-90 disabled:opacity-60"
      >
        {busy ? <Loader2 className="size-4 animate-spin" /> : <XCircle className="size-4" />}
        Conferma disdetta a fine periodo
      </button>
    </div>
  );

  return (
    <MobileModal
      open
      onClose={busy ? undefined : onClose}
      title="Disdetta abbonamento"
      description={`Piano attuale · ${planName}`}
      testid="cancel-subscription-modal"
      size="md"
      showClose={!busy}
      closeOnBackdrop={!busy}
      footer={footer}
    >
      <div className="space-y-4 text-sm">
        <div className="rounded-2xl bg-amber-50/60 border border-amber-200 p-4 flex items-start gap-3">
          <CalendarClock className="size-5 text-amber-700 mt-0.5 shrink-0" />
          <p className="text-dapnow-ink leading-relaxed">
            Il tuo piano resterà attivo fino al termine del periodo già pagato:{" "}
            <strong data-testid="cancel-modal-period-end">{formatDateIT(periodEnd)}</strong>.
            Dopo questa data passerai al piano <strong>Free</strong>.
          </p>
        </div>

        <div className="rounded-2xl border border-emerald-200 bg-emerald-50/60 p-4 flex items-start gap-3">
          <ShieldCheck className="size-5 text-emerald-700 mt-0.5 shrink-0" />
          <div>
            <p className="font-semibold text-emerald-900">
              Le tue consegne incluse restano disponibili
            </p>
            <p className="text-xs text-emerald-900/80 mt-1">
              Fino al <strong>{formatDateIT(periodEnd)}</strong> puoi ancora usare{" "}
              <strong data-testid="cancel-modal-remaining">{remaining}</strong> consegne incluse residue del ciclo corrente.
            </p>
          </div>
        </div>

        <p className="text-xs text-dapnow-muted leading-relaxed">
          Nessun rimborso o prorata: stai semplicemente annullando il rinnovo
          automatico. Puoi riattivare il rinnovo in qualsiasi momento prima
          della scadenza.
        </p>
      </div>
    </MobileModal>
  );
}
